import { render, staticRenderFns } from "./SkeltonLoader.vue?vue&type=template&id=48d95ca2"
import script from "./SkeltonLoader.vue?vue&type=script&lang=js"
export * from "./SkeltonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports